import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { PaymentFailedErrorResultCode } from '@vista-digital/embedded-payments';
import { observer } from 'mobx-react';
import { useContext, useState } from 'react';
import { Button } from '../../../subcomponents/button/button';
import { ButtonColor } from '../../../subcomponents/button/types/color';
import { ButtonSize } from '../../../subcomponents/button/types/size';
import { OrderPaymentFormContextInstance } from '../types/context';
import { OrderPaymentFormEmbeddedPaymentConnector } from './embedded-payment-connector';
import { OrderPaymentFormMessage, OrderPaymentFormMessageType } from './message';
const b = bemClassBuilder('v-order-payment-form-embedded-payment-method');
export const OrderPaymentFormEmbeddedPaymentMethod = observer(props => {
    const { paymentMethodId } = props;
    const { onPaymentSuccessful, onPaymentFailed, displayText } = useContext(OrderPaymentFormContextInstance);
    const [error, setError] = useState();
    const handleInitialisationFailed = () => {
        setError(OrderPaymentFormMessageType.FailedToInitialiseConnector);
    };
    const handlePaymentFailed = (paymentError) => {
        if (paymentError.resultCode === PaymentFailedErrorResultCode.PaymentDeclined) {
            setError(OrderPaymentFormMessageType.PaymentDeclined);
        }
        else {
            setError(OrderPaymentFormMessageType.PaymentFailed);
        }
        onPaymentFailed(paymentError);
    };
    const handleTryAgainButtonClicked = () => {
        setError(undefined);
    };
    const hasPaymentDeclined = error === OrderPaymentFormMessageType.PaymentDeclined;
    if (error && !hasPaymentDeclined) {
        return _jsx(OrderPaymentFormMessage, { messageType: error });
    }
    return (_jsx("div", Object.assign({ className: b.block() }, { children: hasPaymentDeclined ? (_jsx(OrderPaymentFormMessage, Object.assign({ messageType: OrderPaymentFormMessageType.PaymentDeclined }, { children: _jsx(Button, { label: displayText.paymentDeclinedTryAgainButtonLabel, size: ButtonSize.Large, color: ButtonColor.Primary, onClick: handleTryAgainButtonClicked }) }))) : (_jsx(OrderPaymentFormEmbeddedPaymentConnector, { paymentMethodId: paymentMethodId, onInitialisationFailed: handleInitialisationFailed, onPaymentFailed: handlePaymentFailed, onPaymentSuccessful: onPaymentSuccessful })) })));
});
OrderPaymentFormEmbeddedPaymentMethod.displayName = 'OrderPaymentFormMethod';
